@.downloadHandler = ->
    CONTAINERS = [$('.jsDownloadFiles'), $('.jsDownloadImages'), $('.jsDownloadFinishes'), $('.jsDownloadDocuments')];
    imagesFetched = false

    $(document).ready(() ->
        navEvents()
        dropDownCategory()
        #        dropdownGroupProducts()
        showFilteredCadFiles()
        downloadCategoryFiles()
        checkItem()
        downloadSelectedItems()
        switchResourcesCategory()
        changeNavPosition()

        # Show first Category Products
        $('.jsDownloadFilterTag').each(->
            $(this).trigger('click')
        )

        $('.jsDownloadDropdown').each(() ->
            $(this).find('.jsDownloadCategoryList').first().find('.jsListDropdownContentTitle').trigger('click')
            $(this).find('.jsDownloadCategoryList').first().find('.jsListDropdownSubgroupContentTitle').trigger('click')
        )

        # Set active files category
        if window.location.pathname.search('downloads') != -1
            setActiveTab($('.jsDownloadCategory'), CONTAINERS, 'files')
    )

    $(document).on('scroll', ->
        navEvents()
    )

    $(window).on('resize', ->
        navEvents()
    )

    selectedFiles = []
    selectedProducts = []
    selectedImages = []
    selectedDocuments = []

    navEvents = ->
        resourcesContainer = $('.jsResourcesContainer')
        nav = $('.jsResourcesNav')
        resourcesContainerPosition = resourcesContainer.height() - $(window).scrollTop()
        navHeight = nav.height()

        if (window.innerWidth > window.gridBreakpoints.md) # set style on the desktop view
            if (resourcesContainerPosition > navHeight)
                nav.css({position: "fixed", bottom: "unset"})
            else
                nav.css({position: "absolute", bottom: 50})
        else # remove style on the mobile view
            nav.attr('style', '')


    clearCheckedItems = ->
        selectedProducts.length = 0
        selectedImages.length = 0
        selectedDocuments.length = 0

        $('.jsDownloadBox').each(() ->
            $(this).removeClass('checked')
        )
        $('.jsDownloadBtnSelected').attr('disabled', 'true')

    resizeImages = ->
        if (window.innerWidth < window.gridBreakpoints.lg)
            $('.jsDownloadResizeBox').each(() ->
                if ($(this).hasClass('download-site__wrapper__box--3'))
                    $(this).removeClass('download-site__wrapper__box--3').addClass('download-site__wrapper__box--2')
                else if ($(this).hasClass('download-site__wrapper__box--4'))
                    $(this).removeClass('download-site__wrapper__box--4').addClass('download-site__wrapper__box--2')
            )

        if (window.innerWidth < window.gridBreakpoints.md)
            $('.jsDownloadResizeBox').each(() ->
                if ($(this).hasClass('download-site__wrapper__box--2'))
                    $(this).removeClass('download-site__wrapper__box--2').addClass('download-site__wrapper__box--1')
            )

    # Show Category Products
    dropDownCategory = ->
        $('.jsListDropdownContentTitle').on('click', ->
            categoryContainer = $(this).parents('.jsDownloadCategoryList')
            container = categoryContainer.find('.jsListDropdownWrapper')
            option = $(this).parents('.jsDownloadDropdown').data('type')
            categoryUrl = '/products/downloads/' + categoryContainer.data('url') + '/?data-type=' + option

            if container.is(':visible')
                $(this).siblings('.jsDownloadSectionFiles').addClass('disabled')
            else
                $(this).siblings('.jsDownloadSectionFiles').removeClass('disabled')

            if container.children().length < 1
                $.ajax({
                    type: "GET"
                    url: categoryUrl
                    success: (data) =>
                        categoryContainer.toggleClass('active')
                        if categoryContainer.hasClass('active')
                            container.html(data)
                        # TOOD: Temporary blocked
                        # renderOnlyAvaliableProducts()
                        container.slideDown()
                        resizeImages()
                    error: (data) =>
                        console.log("failure " + data)

                    headers: {
                        "X-CSRFToken": getCookie("csrftoken")
                    }
                })
            else
                categoryContainer.toggleClass('active').find('.jsListDropdownWrapper').slideToggle()
        )

    dropdownProductsImages = ->
        $('.jsDownloadSubgroupProduct').on('click', ->

# Dropdown Products List
            $(this).parent('.jsListDropdownSubgroupWrapper').children().each(() ->
                $(this).find('.jsDownloadBoxType').addClass('no-choosed').removeClass('checked')
            )
            $(this).find('.jsDownloadBoxType').addClass('checked').removeClass('no-choosed')

            # Dropdown Product Images
            categoryContainer = $(this).parents('.jsDownloadCategoryList')
            container = categoryContainer.find('.jsDownloadWrapperSubGroup')
            option = categoryContainer.data('type')
            categoryUrl = '/products/downloads/' + categoryContainer.data('url') + '/?data-type=' + option
            productActive = $(this).data('id')
            destination = $(this).parents('.jsDownloadCategoryList').find('.jsDownloadWrapperSubGroup')

            # Get images only at first click on random category
            if container.children().length < 1
                $.ajax({
                    type: "GET"
                    url: categoryUrl
                    success: (data) =>
                        container.html(data)
                        container.show()
                        resizeImages()

                        #scroll to images container
                        $('html, body').animate({scrollTop: destination.offset().top - 80}, 500)
                    error: (data) =>
                        console.log("failure " + data)
                    headers: {
                        "X-CSRFToken": getCookie("csrftoken")
                    }
                })

            # Filter images of selected category
            filteredContainer = container.children().filter(->
                return $(this).attr('data-id') == productActive.toString()
            )

            # Show filtered images
            if filteredContainer.length > 0
                container.children().each(() ->
                    if $(this).data('id') != productActive
                        $(this).hide()
                    else
                        $(this).show()
                )
                container.slideDown()

                # Scroll to images
                $('html, body').animate({scrollTop: destination.offset().top - 80}, 500)
            else
                container.slideUp()
        )

    dropdownGroupProducts = ->
        $('.jsListDropdownSubgroupContentTitle').on('click', ->
            categoryContainer = $(this).parents('.jsDownloadCategoryList')
            container = categoryContainer.find('.jsListDropdownSubgroupWrapper')
            option = $(this).parents('.jsDownloadDropdown').data('type')
            imagesOption = categoryContainer.data('type')
            categoryUrl = '/products/downloads/' + categoryContainer.data('url') + '/?data-type=' + option
            categoryImagesUrl = '/products/downloads/' + categoryContainer.data('url') + '/?data-type=' + imagesOption

            if container.is(':visible')
                $(this).siblings('.jsDownloadSectionFiles').addClass('disabled')
            else
                $(this).siblings('.jsDownloadSectionFiles').removeClass('disabled')
            console.log(container.children().length)
            if container.children().length < 1
# Get all category products
                $.ajax({
                    type: "GET"
                    url: categoryUrl
                    success: (data) =>
                        categoryContainer.toggleClass('active')
                        if categoryContainer.hasClass('active')
                            container.html(data)
                        categoryContainer.find('.jsListDropdownWrapper').slideDown()
                        dropdownProductsImages()
                    error: (data) =>
                        console.log("failure " + data)

                    headers: {
                        "X-CSRFToken": getCookie("csrftoken")
                    }
                })

                # Get all category products images
                $.ajax({
                    type: "GET"
                    url: categoryImagesUrl
                    success: (data) =>
                        subgroupContainer = categoryContainer.find('.jsDownloadWrapperSubGroup')
                        subgroupContainer.html(data)
                        resizeImages()
                    error: (data) =>
                        console.log("failure " + data)
                    headers: {
                        "X-CSRFToken": getCookie("csrftoken")
                    }
                })
            else
                categoryContainer.toggleClass('active').find('.jsListDropdownWrapper').slideToggle()
        )

    # TOOD: Temporary blocked
    #    renderOnlyAvaliableProducts = () ->
    #        avaliableFiles = {}
    #        $('.jsDownloadFiles').find('.jsDownloadsItem').each(->
    #            # showProduct should has selectedFiles.length. if not, hide product
    #            showProduct = 0
    #            elementAttrs = $(this)[0].attributes
    #
    #            for key in Object.keys(elementAttrs)
    #                elementAttrName = elementAttrs[key]['nodeName'].slice(5)
    #                elementAttrValue = elementAttrs[key].value.toLowerCase()
    #                avaliableFiles[elementAttrName] = elementAttrValue
    #
    #            # if product has type file in selectedFiles add true if not false and than hide product
    #            i = 0
    #            while i <= selectedFiles.length
    #                if avaliableFiles[selectedFiles[i]] == 'false'
    #                    showProduct--
    #                else if avaliableFiles[selectedFiles[i]] == 'true'
    #                    showProduct++
    #                else if selectedFiles.length == 0
    #                    showProduct--
    #                i++
    #
    #            if showProduct == selectedFiles.length
    #                $(this).show()
    #            else
    #                $(this).hide()
    #        )

    showFilteredCadFiles = ->
        filterCheckedTypes = (thisElement) ->
            nameTag = $(thisElement)[0].attributes['data-type-item'].value.toLowerCase()
            # If tag is checked add to selected
            if thisElement.is(':checked')
                selectedFiles.push(nameTag)
# If tag isn't checked remove from selected
            else
                elementToRemove = selectedFiles.indexOf(nameTag)
                selectedFiles.splice(elementToRemove, 1)

        $('.jsDownloadFilterTag').on('click', ->
            filterCheckedTypes($(this))
            # TOOD: Temporary blocked
            # renderOnlyAvaliableProducts()

            if($(this).is(':checked'))
                filterId = $(this).attr('data-type-item')
                dropdownItemList = $('.jsDownloadCad').find('.jsListDropdownItem')
                dropdownItemList.each(() ->
                    file = $(this).find('.jsListDropdownWrapper').children()
                    file.each(() ->
                        if($(this).attr('data-type-item') == filterId)
                            $(this).show()
                    )
                )
                $(this).removeAttr('checked')

            else
                $(this).attr('checked', true)
                filterId = $(this).attr('data-type-item')
                dropdownItemList = $('.jsDownloadCad').find('.jsListDropdownItem')

                dropdownItemList.each(() ->
                    file = $(this).find('.jsListDropdownWrapper').children()

                    file.each(() ->
                        if($(this).attr('data-type-item') == filterId)
                            $(this).hide()
                    )
                )
        )

    downloadCategoryFiles = ->
        $('.jsDownloadSectionFiles').on('click', (e) ->
            e.preventDefault()

            # Show modal resources
            $('.jsModalResourcesDownload').addClass('active')

            categoryContainer = $(this).parents('.jsDownloadCategoryList')
            allProductsId = []
            categoryContainer.find('.jsDownloadsItem').each(->
# if $(this).css('display') == 'block'
                allProductsId.push($(this).attr('data-id'))
            )
            data = {}
            if $(this).parents('.jsDownloadImagesSection').length > 0
                data['category'] = $(this).parent().attr('data-category-id')
                data['resource'] = $(this).parent().attr('data-type-files')
            else if  $(this).parents('.jsDownloadDocuments').length > 0
                data['category'] = $(this).parent().attr('data-category-id')
                data['resource'] = $(this).parent().attr('data-type-files')
            else if $(this).parents('.jsDownloadCad').length > 0
                data['cad_products_id'] = allProductsId
                data['models_type'] = selectedFiles

            if allProductsId.length > 0
                downloadFiles(data)
        )

    checkItem = ->
# multicheck Item in Category
        $(document).on('click', '.jsDownloadBox', ->
            $(this).toggleClass('checked')
            downloadBoxChecked = $('.jsDownloadBox.checked')
            btnSelected = $('.jsDownloadBtnSelected')

            if (downloadBoxChecked.length > 0)
                $(btnSelected).removeAttr('disabled')
            else
                $(btnSelected).attr('disabled', true)
        )

    downloadSelectedItems = ->
# Add Item to Array
        addItemToArray = (type, data, array) ->
            $(document).on('click', '.jsDownloadBox', ->
                if $(this).parents('.jsDownloadsItem').data('type-item') == type
                    if $(this).hasClass('checked')
                        array.push($(this).parents('.jsDownloadsItem').data(data))
                    else if $(this).not('.checked')
                        itemId = $(this).parents('.jsDownloadsItem').data(data)
                        item = array.indexOf(itemId)
                        array.splice(item, 1)
            )

        addItemToArray('images', 'image-name', selectedImages)
        addItemToArray('documents', 'id', selectedDocuments)
        addItemToArray('cad_products_id', 'id', selectedProducts)

        # Download Selected Items
        $('.jsDownloadBtnSelected').on('click', ->
            dataItems = {}

            # Remove modal resources
            $('.jsModalResourcesDownload').addClass('active')

            if (Boolean(selectedImages.length))
                dataItems["images"] = selectedImages
            if (Boolean(selectedDocuments.length))
                dataItems["documents"] = selectedDocuments
            if (Boolean(selectedFiles.length) && selectedProducts.length)
                dataItems["models_type"] = selectedFiles
            if (Boolean(selectedFiles.length))
                dataItems["cad_products_id"] = selectedProducts

            downloadFiles(dataItems)
        )

        # Download files for one product
        $(document).on('click', '.jsDownloadProductCadFiles', (e) ->
            e.preventDefault()

            # Remove modal resources
            $('.jsModalResourcesDownload').addClass('active')

            productId = new Array($(this).parents('.jsDownloadsItem').attr('data-id'))
            dataItems = {}
            dataItems['models_type'] = selectedFiles
            dataItems['cad_products_id'] = productId

            downloadFiles(dataItems)
        )

    # switch between categories
    switchResourcesCategory = ->
        containers = CONTAINERS
        categories = $('.jsDownloadCategory')
        categoryImages = $('.jsDownloadImages')
        categoryDocuments = $('.jsDownloadDocuments')
        categoryImages.css('display', 'none')
        categoryDocuments.css('display', 'none')

        categories.each(() ->
            category = $(this)
            param = category.data('param')

            category.on('click', ->
                setParameterByName('resource', param)
                if (!category.hasClass('active'))
                    window.scrollTo({top: 0, behavior: 'smooth'}) # scroll to the top of the page

                # Set clicked category active
                setActiveTab(categories, containers)
            )
        )

    downloadFiles = (dataItems) ->
        xhr = new XMLHttpRequest();
        xhr.open('POST', '/products/downloads/', true);
        xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded;charset=UTF-8");
        xhr.setRequestHeader('X-CSRFToken', getCookie("csrftoken"));
        xhr.onreadystatechange = -> (
            if (xhr.readyState == 4 and xhr.status == 200)
# Remove modal resources
                $('.jsModalResourcesDownload').removeClass('active')

                fileName = "";
                disposition = xhr.getResponseHeader('Content-Disposition')
                if (disposition && disposition.indexOf('attachment') != -1)
                    filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
                    matches = filenameRegex.exec(disposition)
                    if (matches != null && matches[1])
                        fileName = matches[1].replace(/['"]/g, '')

                blob = new Blob([xhr.response], {type: "octet/stream"});

                clearCheckedItems()

                if (typeof window.navigator.msSaveBlob != 'undefined')
                    window.navigator.msSaveBlob(blob, fileName)
                else
                    URL = window.URL || window.webkitURL
                    downloadUrl = URL.createObjectURL(blob)

                    if (fileName)
                        a = document.createElement("a")
                        if (typeof a.download == 'undefined')
                            window.location = downloadUrl
                        else
                            a.href = downloadUrl
                            a.download = fileName
                            document.body.appendChild(a)
                            a.click()
                            a.remove()
                    else
                        window.location = downloadUrl

                    setTimeout (->
                        URL.revokeObjectURL(downloadUrl)
                    ), 100


            if (xhr.status == 404)
                null
# hook for handling empty resources
        )
        xhr.responseType = "arraybuffer";
        serialize = (obj, prefix) -> (
            str = []
            for p of obj
                if (obj.hasOwnProperty(p))
                    pIndex = if obj instanceof Array then pIndex = '' else p
                    k = if prefix then prefix + "[" + pIndex + "]" else pIndex
                    v = obj[p]
                    str.push(if v != null && typeof v == "object" then serialize(v, k) else encodeURIComponent(k) + "=" + encodeURIComponent(v))
            return str.join("&")
        )
        xhr.send(serialize(dataItems))

    changeNavPosition = () ->
        $(window).on('scroll', (e) ->
            footer = $('.jsFooter')
            navBar = $('.jsDownloadNavBar')
            navMenu = $('.jsDownloadNavMenu')
            navBarPosition = $(window).scrollTop() + 466
            footerPosition = footer.position().top

            if (window.innerWidth > window.gridBreakpoints.sm)
                if (navBarPosition >= footerPosition)
                    navBar.css({'position': "absolute"})
                    navMenu.css({'position': "absolute", "bottom": 100})
                else
                    navBar.css('position', "fixed")
                    navMenu.css({'position': "fixed", "bottom": "unset"})
            else
                navBar.css('position', "relative")
                navMenu.css('position', "static")
        )

    setActiveTab = (categories, containers, defaultParam = '') ->
# Set first category active as default if there is no param
        if !getParameterByName('resource') then setParameterByName('resource', $(categories[0]).data('param'))

        categories.each((idx) ->
            cat = categories[idx]
            queryParam = getParameterByName('resource') || defaultParam

            if (queryParam == $(cat).data('param'))
                $(cat).addClass('active')
                containers[idx].slideDown()
                if queryParam == 'images'
                    if !imagesFetched
                        dropdownGroupProducts()
                    else
                        imagesFetched = true
            else
                $(cat).removeClass('active')
                containers[idx].slideUp()
        )
